import React, { useState, type ComponentType } from 'react';
import { IsFhsEnabledProvider } from '@atlaskit/navigation-system/fhs-rollout';
import { expVal } from '@atlassian/jira-feature-experiments';
import { componentWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { useLeftSidebarState } from '@jira/platform__controllers-layout/src/controllers/layout-controller/consumers/left-sidebar-controller/index.tsx';
import {
	PageLayout,
	type PageLayoutProps,
} from '@jira/design-system__navigation-system/src/PageLayout.tsx';

// Used when full height sidebar is enabled
const PageLayoutWithFHSChanges = ({ children, ...props }: PageLayoutProps) => {
	const { isCollapsed } = useLeftSidebarState();
	const [defaultSideNavCollapsed] = useState(isCollapsed);

	return (
		<IsFhsEnabledProvider value>
			<PageLayout
				{...props}
				defaultSideNavCollapsed={defaultSideNavCollapsed}
				isSideNavShortcutEnabled
			>
				{children}
			</PageLayout>
		</IsFhsEnabledProvider>
	);
};

const PageLayoutWithoutFhsChanges = ({ children, ...props }: PageLayoutProps) => (
	<IsFhsEnabledProvider value={false}>
		<PageLayout {...props}>{children}</PageLayout>
	</IsFhsEnabledProvider>
);

export const JiraPageLayout: ComponentType<PageLayoutProps> = componentWithCondition(
	() => expVal('navx-full-height-sidebar-exp', 'isEnabled', false),
	PageLayoutWithFHSChanges,
	PageLayoutWithoutFhsChanges,
);
